import React, { useState, useMemo } from "react";

import ProductReviewItem from "./ProductReviewItem";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const REVIEW_FILTERS = [
  { id: "all", label: "All" },
  { id: "verified", label: "Owners" },
];

const ProductReviewsListSection = ({
  reviews,
  editingReview,
  editReviewForm,
  formConfig = null,
  onEditFormChange,
  onSaveEdit,
  onCancelEdit,
  onHelpful,
  onEditStart,
  onDelete,
  canEditReview,
  onOpenAllReviews,
}) => {
  const [activeFilter, setActiveFilter] = useState("all");

  const filteredReviews = useMemo(() => {
    if (activeFilter === "verified") return reviews.filter((r) => r.inSetup);
    return reviews;
  }, [reviews, activeFilter]);

  if (!reviews.length) {
    return <p className={styles.noReviews}>No reviews yet. Be the first to review!</p>;
  }

  const approvedCount = reviews.filter((review) => review.approved).length;
  const ownerCount = reviews.filter((review) => review.inSetup && review.approved).length;

  const getLabel = (filter) => {
    if (filter.id === "verified") return `Owners (${ownerCount})`;
    return `All (${approvedCount})`;
  };

  return (
    <>
      <div className={styles.reviewFilterTabs}>
        {REVIEW_FILTERS.map((f) => (
          <button
            key={f.id}
            type="button"
            className={`${styles.reviewFilterTab} ${activeFilter === f.id ? styles.reviewFilterTabActive : ""}`}
            onClick={() => setActiveFilter(f.id)}
          >
            {getLabel(f)}
          </button>
        ))}
      </div>

      {filteredReviews.length === 0 ? (
        <p className={styles.noReviews}>
          {activeFilter === "verified"
            ? "No owner reviews yet."
            : "No reviews to show."}
        </p>
      ) : (
        <div className={styles.reviewsList}>
          {filteredReviews.map((review) => (
            <ProductReviewItem
              key={review._id}
              review={review}
              isEditing={editingReview === review._id}
              editReviewForm={editReviewForm}
              formConfig={formConfig}
              onEditFormChange={onEditFormChange}
              onSaveEdit={() => onSaveEdit(review._id)}
              onCancelEdit={onCancelEdit}
              onHelpful={() => onHelpful(review._id)}
              onEditStart={() => onEditStart(review)}
              onDelete={() => onDelete(review._id)}
              canEdit={canEditReview(review)}
            />
          ))}
        </div>
      )}

      <div className={styles.viewAllReviewsContainer}>
        <button className={styles.viewAllReviewsBtn} onClick={onOpenAllReviews} type="button">
          View All Reviews ({approvedCount})
        </button>
      </div>
    </>
  );
};

export default ProductReviewsListSection;
